import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
//import HelloComponent3 from './components/HelloComponent3';

//การสร้างcomponent
/*
function HelloComponent(){
  return <h1> สวัสดี Component</h1>
}
function HelloComponent2(){
  return <h1> ทดสอบ</h1>
}
  */
//การสร้าง Component แบบ class
/*
class HelloComponentclass extends React.Component{
  render(){
    return <h1>สวัสดี Component แบบ class ครับผม</h1>
  }
}
  */
/*
//แบบก้องสอน
ReactDOM.render(<HelloComponent/>,document.getElementById('root'));
*/

//ประยุคใช้เอง
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App/>

  </React.StrictMode>
    
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
